document.querySelector("#contact_form").addEventListener("submit", function(e) {
  e.preventDefault();

  // Capture form data
  const name = document.querySelector("input[name='contact[name]']").value;
  const email = document.querySelector("input[name='contact[email]']").value;
  const number = document.querySelector("input[name='contact[phone]']").value;
  const watchModel = document.querySelector("input[name='contact[model]']").value;
  const message = document.querySelector("textarea[name='contact[body]']").value;

  // Format WhatsApp message
  const whatsappMessage = `Hello, my name is ${name}. My email is ${email}.\nMy contact number is ${number}. ${message}`;
  const whatsappURL = `http://wa.me/+9613445443?text=${encodeURIComponent(whatsappMessage)}`;

  // Redirect to WhatsApp
  //window.location.href = whatsappURL;
  window.open(whatsappURL, '_blank');
});